import React from 'react'
import Radium from 'radium'
import { isAmwellTheme } from '../../../lib/util'

const styles = {
  addProblemButton: {
    margin: '15px 0px 0px 10px',
    color: '#2D5F60',
    fontWeight: 600,
    padding: '15px',
    width: 'fit-content',
    borderRadius: '10px',
    ':hover': {
      background: '#F8F8F8'
    }
  }
}

const stylesDark = {
  addProblemButton: {
    margin: '8px 0px 0px 0px',
    color: '#46aff2',
    fontWeight: 'bold',
    padding: '16px',
    width: 'fit-content',
    borderRadius: '10px',
    ':hover': {
      background: '#232a30'
    },
    fontSize: '16px'
  }
}

const AddProblemButton = props => {
  const isAmwellDark = isAmwellTheme()

  return (
    <div
      style={!isAmwellDark ? styles.addProblemButton : stylesDark.addProblemButton}
      onClick={props.handleAddProblem}
      data-cy='new-problem-button'
    >
      +&nbsp;&nbsp;New Problem
    </div>
  )
}

export default Radium(AddProblemButton)
